<!-- 保养项 -->
<template>
	<div style="display: inline;">
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/equipment/maintain/bill/item/page"
			getKey="rows" :columns="columns">
			<template #conditions>
					<el-form size="mini" :inline="true" :model="yt.editObj" class="demo-form-inline">
						<el-form-item :label="$t('baoyangdanhao')" class="noborder">
							<el-input disabled v-model="$attrs.maintainRecordItem.no"></el-input>
						</el-form-item>
						<el-form-item :label="$t('shebeimingcheng')" class="noborder">
							<el-input disabled v-model="$attrs.maintainRecordItem.equipment.name"></el-input>
						</el-form-item></br>
						<el-form-item :label="$t('baoyangfangshi')" class="noborder">
							<el-input disabled :value="$t(store.state.dictJson['EQUIPMENT_MAINTAIN_MODE'][$attrs.maintainRecordItem.mode])"></el-input>
						</el-form-item>
						<el-form-item :label="$t('beizhu')" class="noborder" label-width="68px">
							<el-input disabled v-model="$attrs.maintainRecordItem.remark"></el-input>
						</el-form-item></br>
						<el-form-item :label="$t('baoyangpingjia')">
							{{$attrs.maintainRecordItem.comment}}
						</el-form-item>
					</el-form>
			</template>
		</yi_curd_table>
			
	</div>
</template>

<script type="text/javascript">
	export default {
		name: 'web_equipment_resume_maintenance_record_item',
		data() {
			return {
				fixConditions: {
					"billId": this.$attrs.maintainRecordItem.id
				},
				columns: [{
					label: 'baoyangbuwei',
					prop: 'part',
					width: 130
				}, {
					label: 'baoyangneirong',
					prop: 'content',

				}, {
					label: 'zhuyishixiang',
					prop: 'attention',

				}, {
					label: 'baoyangzhouqi',
					prop: 'cycle',

				}, {
					label: 'shangcibaoyangshijian',
					prop: 'lastMaintainTime',
					type: 'time'

				}, {
					label: 'baoyangzhuangtai',
					type: 'tag',
					prop: 'status',
					tags: {
						1: {
							color: '#F56C6C',
							text: this.$t('weibaoyang')
						},
						2: {
							color: '#E6A23C',
							text: this.$t('baoyangzhong')
						},
						3: {
							color: '#67C23A',
							text: this.$t('yiwancheng')
						}
					},
				}]
			};
		},
		created() {
			
			setTimeout(() => {
				this.yt.conditions = {
					billId: this.$attrs.maintainRecordItem.id,
					pageSize: 10
				}
				this.yt.isShowPagination = true
				this.yt.get(1);
			}, 300)
		},
		computed:{
			isAllStarted(){
				for (var i = 0; i < this.yt.list.length; i++) {
					if(this.yt.list[i].status=="1"){
						return false
					}
				}
				return true
			},
			isAllFinish(){
				for (var i = 0; i < this.yt.list.length; i++) {
					if(this.yt.list[i].status!="3" && this.yt.list[i].status!="1"){
						return false
					}
				}
				return true
			}
		},
		methods: {
			refresh(){
				this.$attrs.maintainRecordItem.comment = this.yt.editObj.comment;
				this.yt.get(1);
				this.utils.event_hub.$emit('BASE_MAINTENANCE_REFRESH');
			}
		}
	};
</script>


<style>
</style>
